@if (isImage() && downloadUrl()) {
    <img
        [src]="downloadUrl()"
        [alt]="`Bildvorschau für ${fileName()}`"
    />
} @else {
    <i [ctrlIcon]="icon()"></i>
}
<div class="file-details">
    <p class="flex fw:semibold m-4:b">
        @if (splittedFileName().length === 3) {
            <span class="ellipsify">{{ splittedFileName()[1] }}</span
            ><span class="extension">{{ splittedFileName()[2] }}</span>
        } @else {
            {{ fileName() }}
        }
    </p>
    <p class="m-0 fs:xs">
        {{ fileAttachment().documentTypeId | damageDocumentType$: insuranceTypeId() | async }}
    </p>
</div>
@if (downloadUrl()) {
    <a
        class="download-link"
        [attr.aria-label]="`${fileName()} herunterladen`"
        [href]="downloadUrl()"
        [download]="fileName()"
        ><i ctrlIcon="download"></i
    ></a>
}
